/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * Staffing API
 * OpenAPI spec version: 1.0.0
 */

export type ExternalAgentDeliveryStatus =
  (typeof ExternalAgentDeliveryStatus)[keyof typeof ExternalAgentDeliveryStatus];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ExternalAgentDeliveryStatus = {
  sent: 'sent',
  pending: 'pending',
  failed: 'failed',
  skipped: 'skipped',
} as const;
